import React from 'react';

import './index.css';


const getText = () => (
  <div styleName="textContainer">
    {/* Unlike with Market Orders, which are executed shortly after they reach the market, for Limit,
    Stop or Stop/Limit orders, you need to specify the Expiration, which is how long you would like
    your order to remain open for execution. */}
    For Limit or Stop/Limit orders, you need to specify the Expiration, which is how long you would like
    your order to remain open for execution.
    <br />
    <br />
    Your order will remain open until either the limit price or stop price is met and the order is
    executed, or at the end of the specified time period:
    <br />
    <br />
    <div styleName="bulleted">
      <strong>Day:</strong>&nbsp;A Day order means that your order is good until the market closes
      on that day (or the next trading day if you place your order when the market is closed).
      If at the end of that day your order has not been filled, then it is canceled.
    </div>
    <br />
    <div styleName="bulleted">
      <strong>GTC:</strong>&nbsp;A Good ‘Till Cancelled (GTC) Order () means that your order will
      remain open either until it is executed or for 90 days, whichever comes first. If the 90th
      day falls on a weekend or holiday, the order will expire on the next business day.
    </div>
    <br />
    One thing to keep in mind is that GTC Limit Orders and GTC Stop/Limit orders are sent to the
    market as All or None orders. Therefore, even if your price target is met, there is a chance
    that your GTC order will not be filled, since all unrestricted orders at that price must be
    filled first.
    <br />
    <br />
    {/* All other orders (Market, Stop, Limit Day, Stop-Limit Day and GTC Stop Orders) are sent to */}
    All other orders (Limit Day, Stop-Limit Day and GTC Stop Orders) are sent to
    market with no conditions. As a result, for these orders, there could be a time when only part
    of your order is executed (e.g., 400 of 1000 shares are executed as part of a partial order
    execution).
  </div>
);

export default getText;



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/DisclaimerViews/ExpirationText.js